var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-badge',{attrs:{"variant":"secondary"}},[_vm._v(" "+_vm._s(_vm.filename)+" "),_c('feather-icon',{staticClass:"cursor-pointer",attrs:{"size":"16","icon":"XCircleIcon"},on:{"click":_vm.removeItem}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }